function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeatingWater(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 82 82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.65,66.75l35.18,0A2.74,2.74,0,0,0,57.36,64a2.56,2.56,0,0,0-2.53-2.83H10.25V22.06H22.46",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.8px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.65,66.75a2.58,2.58,0,0,0-2.54,2.84,2.75,2.75,0,0,0,2.54,2.78h36.1",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.8px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "18.53 18.02 22.56 22.06 18.53 26.09",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.8px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "58.75 22.06 69.68 22.06 69.68 72.46 59.34 72.46",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.8px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "63.28 76.5 59.24 72.46 63.28 68.42",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.8px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M32.23,36.37a6.76,6.76,0,0,0-2.62,4.88,6.71,6.71,0,0,0,1.31,5.37",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M29.62,56.88A6.77,6.77,0,0,0,32.24,52a6.71,6.71,0,0,0-1.32-5.37",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M50.82,36.37a6.76,6.76,0,0,0-2.62,4.88,6.71,6.71,0,0,0,1.31,5.37",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M48.2,56.88A6.77,6.77,0,0,0,50.82,52a6.73,6.73,0,0,0-1.31-5.37",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M41.53,36.37a6.76,6.76,0,0,0-2.62,4.88,6.66,6.66,0,0,0,1.31,5.37",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M38.91,56.88A6.77,6.77,0,0,0,41.53,52a6.73,6.73,0,0,0-1.31-5.37",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M48.25,29.69c0,5.09-3.39,11.81-11.73,11.81S24.8,34.78,24.8,29.69c0-8.83,11.72-21,11.72-21S48.25,20.86,48.25,29.69Z",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.8px",
      fill: "#fff",
      stroke: "currentColor"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M38.24,36.61a6.42,6.42,0,0,1-5.42-.52,6.52,6.52,0,0,1-3.55-4.17",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.7px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M57.2,30.55a5.79,5.79,0,1,1-11.58,0c0-4.35,5.79-10.35,5.79-10.35S57.2,26.2,57.2,30.55Z",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.8px",
      fill: "#fff",
      stroke: "currentColor"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M52.56,33.52a3.17,3.17,0,0,1-2.68-.26,3.2,3.2,0,0,1-1.76-2",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.3px"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeatingWater);
export default __webpack_public_path__ + "static/media/heating_water.6040077c1076ac5f02693f2980bab695.svg";
export { ForwardRef as ReactComponent };